// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* cCarNumber */
.car-number-wrap {
    background: none;
}
.car-number-wrap .edit-btn {
    border: 1px solid #cccccc;
    width: 20px;
    height: 20px;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    padding: 2px;
    color: #333333;
    background-color: #ffffff;
}

.on-visit .edit-btn {
    vertical-align: top;
    margin-top: 5px;
}

span.edit-btn:hover,
span.edit-btn:focus,
span.edit-btn:active {
    color: #333333;
    background-color: #e6e6e6;
    border-color: #adadad;
}
span.edit-btn.disabled,
span.edit-btn[disabled],
span.edit-btn.disabled:hover,
span.edit-btn[disabled]:hover,
span.edit-btn.disabled:focus,
span.edit-btn[disabled]:focus,
span.edit-btn.disabled:active,
span.edit-btn[disabled]:active {
    opacity: 0.4;
    background-color: #ffffff;
    border-color: #cccccc;
}

.car-number {
    border-collapse: separate !important;
    border: 1px solid #444;
    padding: 0 3px 0 4px;
    border-radius: 4px;
    text-decoration: none !important;
    width: 110px;
    height: 30px;
    font-size: 16px;
    font-weight: 500;
    color: #000;
}

.car-number-wrap .edit-btn-wrap {
    position: absolute;
    margin-top: 10px;
}
.car-number-wrap.edit-mode .edit-btn-wrap {
    position: inherit;
    margin-top: 0px;
}

.car-number.edit-mode .car-number-type-dropdown {
    display: inline-block;
    vertical-align: middle;
}

.car-number-editor{
    width: 80px;
    color: black;
    font-size: 85%;
}

/* Specify styling for tooltip contents */
.tooltip.errorsClass .tooltip-inner {
    color: #880000;
    background-color: #fffea1;
    box-shadow: 0 6px 12px rgba(0,0,0,.175);
}

/*.car-number-type-select-wrap {*/
/*position: absolute;*/
/*}*/
/*.car-number-type-select{*/
/*width: 80px;*/
/*margin-bottom: 2px;*/
/*color: black;*/
/*font-size: 14px;*/
/*}*/
.car-number.citizen, .car-number.unknown, .car-number.motorbike, .car-number.transit {
    background: #fdfdfd;
}
.car-number.diplomatical, .car-number.military, .car-number.police {
    color: white;
    border-color: #B9B3B3;
}
.car-number.diplomatical .n4, .car-number.military .n4, .car-number.police .n4 {
    border-color: white;
}
.car-number .car-number-type-dropdown a span.caret {
    margin-left: 0px;
    margin-right: 2px;
    margin-bottom: 2px;
}
.car-number.diplomatical .car-number-type-dropdown a span.caret ,
.car-number.military .car-number-type-dropdown a span.caret,
.car-number.police .car-number-type-dropdown a span.caret {
    color: white;
}
.car-number.citizen .n1,
.car-number.citizen .n3,
.car-number.unknown .n1,
.car-number.unknown .n3,
.car-number.police .n1,
.car-number.taxi .n1,
.car-number.diplomatical .n2,
.car-number.military .n2,
.car-number.motorbike .n2,
.car-number.transit .n2 {
    font-size: 80%;
}
.car-number.transit .n2 {
    padding-left: 2px;
}
.car-number.transit .n1 {
    border-right: 1px solid #444;
    padding-right: 3px;
}
.car-number.diplomatical .n1,
.car-number.military .n1,
.car-number.motorbike .n1,
.car-number.citizen .n2,
.car-number.unknown .n2 {
    padding: 0 1px 0 2px;
}
.car-number.military .n2,
.car-number.motorbike .n2,
.car-number.police .n2,
.car-number.taxi .n2,
.car-number.citizen .n3,
.car-number.unknown .n3,
.car-number.diplomatical .n3,
.car-number.transit .n3 {
    padding-right: 4px;
}
/*.car-number.motorbike .n4 {*/
/*border-left: solid 1px #444;*/
/*border-top: solid 1px #444;*/
/*padding-left: 2px;*/
/*}*/
.car-number .n4 {
    border-left: 1px solid #444;
}
.car-number.diplomatical {
    background: red;
}
.car-number.military {
    background: black;
}
/*.car-number.motorbike {*/
/*width: 50px;*/
/*font-size: 15px;*/
/*height: 45px;*/
/*}*/
.car-number.police {
    background: #064db9;
}
.car-number.taxi {
    background: #ffd800;
}

table.car-number:hover {
    cursor: default;
    opacity: 0.4;
    filter: alpha(opacity=40);
}

a table.car-number:hover {
    cursor: pointer;
}

table.car-number.edit-mode:hover {
    cursor: default;
    opacity: 1;
    filter: alpha(opacity=100);
}

a table.car-number.edit-mode:hover {
    cursor: default;
}

table.car-number.no-hover:hover {
    opacity: 1 !important;
    filter: none !important;
    cursor: default !important;
}
`, "",{"version":3,"sources":["webpack://./src/legacy/styles/car-number.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;;;;;;;;IAQI,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,yCAAyC;AACzC;IACI,cAAc;IACd,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA,iCAAiC;AACjC,sBAAsB;AACtB,IAAI;AACJ,2BAA2B;AAC3B,eAAe;AACf,sBAAsB;AACtB,gBAAgB;AAChB,mBAAmB;AACnB,IAAI;AACJ;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;;IAGI,YAAY;AAChB;AACA;;;;;;;;;;IAUI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;;;;;IAKI,oBAAoB;AACxB;AACA;;;;;;;;IAQI,kBAAkB;AACtB;AACA,8BAA8B;AAC9B,+BAA+B;AAC/B,8BAA8B;AAC9B,qBAAqB;AACrB,IAAI;AACJ;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA,0BAA0B;AAC1B,eAAe;AACf,mBAAmB;AACnB,gBAAgB;AAChB,IAAI;AACJ;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;AAC9B","sourcesContent":["/* cCarNumber */\n.car-number-wrap {\n    background: none;\n}\n.car-number-wrap .edit-btn {\n    border: 1px solid #cccccc;\n    width: 20px;\n    height: 20px;\n    font-size: 14px;\n    cursor: pointer;\n    text-align: center;\n    padding: 2px;\n    color: #333333;\n    background-color: #ffffff;\n}\n\n.on-visit .edit-btn {\n    vertical-align: top;\n    margin-top: 5px;\n}\n\nspan.edit-btn:hover,\nspan.edit-btn:focus,\nspan.edit-btn:active {\n    color: #333333;\n    background-color: #e6e6e6;\n    border-color: #adadad;\n}\nspan.edit-btn.disabled,\nspan.edit-btn[disabled],\nspan.edit-btn.disabled:hover,\nspan.edit-btn[disabled]:hover,\nspan.edit-btn.disabled:focus,\nspan.edit-btn[disabled]:focus,\nspan.edit-btn.disabled:active,\nspan.edit-btn[disabled]:active {\n    opacity: 0.4;\n    background-color: #ffffff;\n    border-color: #cccccc;\n}\n\n.car-number {\n    border-collapse: separate !important;\n    border: 1px solid #444;\n    padding: 0 3px 0 4px;\n    border-radius: 4px;\n    text-decoration: none !important;\n    width: 110px;\n    height: 30px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #000;\n}\n\n.car-number-wrap .edit-btn-wrap {\n    position: absolute;\n    margin-top: 10px;\n}\n.car-number-wrap.edit-mode .edit-btn-wrap {\n    position: inherit;\n    margin-top: 0px;\n}\n\n.car-number.edit-mode .car-number-type-dropdown {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.car-number-editor{\n    width: 80px;\n    color: black;\n    font-size: 85%;\n}\n\n/* Specify styling for tooltip contents */\n.tooltip.errorsClass .tooltip-inner {\n    color: #880000;\n    background-color: #fffea1;\n    box-shadow: 0 6px 12px rgba(0,0,0,.175);\n}\n\n/*.car-number-type-select-wrap {*/\n/*position: absolute;*/\n/*}*/\n/*.car-number-type-select{*/\n/*width: 80px;*/\n/*margin-bottom: 2px;*/\n/*color: black;*/\n/*font-size: 14px;*/\n/*}*/\n.car-number.citizen, .car-number.unknown, .car-number.motorbike, .car-number.transit {\n    background: #fdfdfd;\n}\n.car-number.diplomatical, .car-number.military, .car-number.police {\n    color: white;\n    border-color: #B9B3B3;\n}\n.car-number.diplomatical .n4, .car-number.military .n4, .car-number.police .n4 {\n    border-color: white;\n}\n.car-number .car-number-type-dropdown a span.caret {\n    margin-left: 0px;\n    margin-right: 2px;\n    margin-bottom: 2px;\n}\n.car-number.diplomatical .car-number-type-dropdown a span.caret ,\n.car-number.military .car-number-type-dropdown a span.caret,\n.car-number.police .car-number-type-dropdown a span.caret {\n    color: white;\n}\n.car-number.citizen .n1,\n.car-number.citizen .n3,\n.car-number.unknown .n1,\n.car-number.unknown .n3,\n.car-number.police .n1,\n.car-number.taxi .n1,\n.car-number.diplomatical .n2,\n.car-number.military .n2,\n.car-number.motorbike .n2,\n.car-number.transit .n2 {\n    font-size: 80%;\n}\n.car-number.transit .n2 {\n    padding-left: 2px;\n}\n.car-number.transit .n1 {\n    border-right: 1px solid #444;\n    padding-right: 3px;\n}\n.car-number.diplomatical .n1,\n.car-number.military .n1,\n.car-number.motorbike .n1,\n.car-number.citizen .n2,\n.car-number.unknown .n2 {\n    padding: 0 1px 0 2px;\n}\n.car-number.military .n2,\n.car-number.motorbike .n2,\n.car-number.police .n2,\n.car-number.taxi .n2,\n.car-number.citizen .n3,\n.car-number.unknown .n3,\n.car-number.diplomatical .n3,\n.car-number.transit .n3 {\n    padding-right: 4px;\n}\n/*.car-number.motorbike .n4 {*/\n/*border-left: solid 1px #444;*/\n/*border-top: solid 1px #444;*/\n/*padding-left: 2px;*/\n/*}*/\n.car-number .n4 {\n    border-left: 1px solid #444;\n}\n.car-number.diplomatical {\n    background: red;\n}\n.car-number.military {\n    background: black;\n}\n/*.car-number.motorbike {*/\n/*width: 50px;*/\n/*font-size: 15px;*/\n/*height: 45px;*/\n/*}*/\n.car-number.police {\n    background: #064db9;\n}\n.car-number.taxi {\n    background: #ffd800;\n}\n\ntable.car-number:hover {\n    cursor: default;\n    opacity: 0.4;\n    filter: alpha(opacity=40);\n}\n\na table.car-number:hover {\n    cursor: pointer;\n}\n\ntable.car-number.edit-mode:hover {\n    cursor: default;\n    opacity: 1;\n    filter: alpha(opacity=100);\n}\n\na table.car-number.edit-mode:hover {\n    cursor: default;\n}\n\ntable.car-number.no-hover:hover {\n    opacity: 1 !important;\n    filter: none !important;\n    cursor: default !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
